import React from 'react';
import PropTypes from 'prop-types';
import Hidden from '@material-ui/core/Hidden';
import { connect } from 'react-redux';
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import PublicLayoutMobile from './PublicLayoutMobile';
import PublicLayoutDesktop from './PublicLayoutDesktop';
import organizationDuck from '../redux/modules/organizationDuck';
import railsContextDuck from '../redux/modules/railsContextDuck';

import baseballBackgroundImage from '../assets/images/backgrounds/baseball/baseball1.jpg';
import basketballBackgroundImage from '../assets/images/backgrounds/basketball/basketball1.jpg';
import footballBackgroundImage from '../assets/images/backgrounds/football/football1.jpg';
import genericBackgroundImage from '../assets/images/backgrounds/generic/generic1.jpg';
import hockeyBackgroundImage from '../assets/images/backgrounds/hockey/hockey1.jpg';
import lacrosseBackgroundImage from '../assets/images/backgrounds/lacrosse/lacrosse1.jpg';
import soccerBackgroundImage from '../assets/images/backgrounds/soccer/soccer1.jpg';
import softballBackgroundImage from '../assets/images/backgrounds/softball/softball1.jpg';
import volleyballBackgroundImage from '../assets/images/backgrounds/volleyball/volleyball1.jpg';
import wrestlingBackgroundImage from '../assets/images/backgrounds/wrestling/wrestling1.jpg';
import BottomNavigationContainer from './BottomNavigationContainer';
// import LeftSidenav from '../components/Public/LeftSidenav/LeftSidenav';
import usePublicLayoutDisabled from './usePublicLayoutDisabled';
import Helmet from 'react-helmet';
import OrganizerLayoutUIJDesktop from './OrganizerLayoutUIJDesktop';

const selectDefaultBackground = (sport, s3LayoutUrl) => {
  if (s3LayoutUrl) return s3LayoutUrl;
  switch (sport) {
    case 'Baseball':
      return baseballBackgroundImage;
    case 'Softball':
      return softballBackgroundImage;
    case 'Basketball':
      return basketballBackgroundImage;
    case 'Football':
      return footballBackgroundImage;
    case 'Hockey':
      return hockeyBackgroundImage;
    case 'Lacrosse':
      return lacrosseBackgroundImage;
    case 'Soccer':
      return soccerBackgroundImage;
    case 'Volleyball':
      return volleyballBackgroundImage;
    case 'Wrestling':
      return wrestlingBackgroundImage;
    case 'Multi-Sport':
      return genericBackgroundImage;
    case 'Other':
      return genericBackgroundImage;
    default:
      return genericBackgroundImage;
  }
};

const mapStateToProps = store => {
  const {
    $$contactInfoStore,
    $$organizationStore,
    $$railsContextStore,
  } = store;
  const canEditOrganization = organizationDuck.selectors.canEditOrganization(
    $$organizationStore,
    $$railsContextStore
  );
  const isPreviewingWebsite = railsContextDuck.selectors.isPreviewingWebsite(
    $$railsContextStore
  );
  const isEditingOrganization = canEditOrganization && !isPreviewingWebsite;
  const organizationTheme = organizationDuck.selectors.organizationTheme(
    $$organizationStore
  );
  const s3LayoutUrl = $$organizationStore.getIn([
    '$$organization',
    'show_layout',
  ])
    ? $$organizationStore.getIn(['$$organization', 's3_layout_url'])
    : null;
  return {
    $$currentUser: $$railsContextStore.get('$$currentUser'),
    $$navbarItems: $$organizationStore.get('$$navbarItems'),
    $$organization: $$organizationStore.get('$$organization'),
    additionalInfo: $$contactInfoStore.get('additionalInfo'),
    $$flash: $$railsContextStore.get('$$flash'),
    organizationBackgroundImage: selectDefaultBackground(
      $$organizationStore.getIn(['$$organization', 'sport']),
      s3LayoutUrl
    ),
    canEditOrganization,
    isPreviewingWebsite,
    isEditingOrganization,
    isChatEnabled: $$organizationStore.getIn([
      '$$organization',
      'is_chat_enabled',
    ]),
    isUserSignedIn: organizationDuck.selectors.isUserSignedIn(
      $$railsContextStore
    ),
    organizationTheme,
  };
};

const PublicLayout = props => {
  const { viewDisabled, searchIndexDisabled } = usePublicLayoutDisabled();
  // React.useEffect(() => {
  //   props.$$flash.forEach(el => {
  //     const [type, message] = el;
  //     if (type === 'alert') {
  //       toast.error(message);
  //     } else if (type === 'notice') {
  //       toast.success(message);
  //     }
  //   });
  // }, []);

  return (
    <ThemeProvider theme={props.organizationTheme}>
      <Helmet>
        {searchIndexDisabled && <meta name="robots" content="noindex" />}
      </Helmet>
      <CssBaseline />
      <Hidden mdUp>
        <PublicLayoutMobile viewDisabled={viewDisabled} {...props} />
        <BottomNavigationContainer />
      </Hidden>
      <Hidden smDown>
        <div>
          {props.canEditOrganization ? (
            <OrganizerLayoutUIJDesktop hideAppBar>
              <PublicLayoutDesktop viewDisabled={viewDisabled} {...props} />
            </OrganizerLayoutUIJDesktop>
          ) : (
            <PublicLayoutDesktop viewDisabled={viewDisabled} {...props} />
          )}
        </div>
      </Hidden>
    </ThemeProvider>
  );
};

PublicLayout.propTypes = {
  organizationTheme: PropTypes.object.isRequired,
  $$flash: PropTypes.array.isRequired,
};
PublicLayout.defaultProps = {};

export default connect(mapStateToProps)(PublicLayout);
